// extracted by mini-css-extract-plugin
module.exports =  {"container":"i8j0MBX","icon":"b7abbg3"};